import { filter } from "lodash";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Box, Button, Flex } from "rebass";
import useResponsive from "../../hooks/useResponsive";
import Ccontinuous from "../../icons/Ccontinuous";
import Close from "../../icons/Close";
import Gallery from "../../icons/Gallery";
import HangerBG from "../../icons/HangerBG";
import Heart from "../../icons/Heart";
import Reversible from "../../icons/Reversible";
import { systemActions, yodaCatalogueActions } from "../../logic/actions";
import { getLocalizedString } from "../../utils";
import { getLocalizedText } from "../../utils/getLocalizedText";
import config from "../../utils/globalConfig";
import sizeSort from "../../utils/sizeSort";
import AvailabilityGridDoor from "../availability/AvailabilityGridDoor";
import { ColorTooltip } from "../common/ColorTooltip";
import { Price } from "../common/Price";
import { ProductImage } from "../common/ProductImage";
import Tooltip from "../common/Tooltip";
import { PopupImages } from "./PopupImages";
import ProductDescription from "./ProductDescription";
import TableSize from "./TableSize";
import Whishlist from "../../icons/Whishlist";
import Notify from "../../icons/Notify";
function ProductSwapNew({
  id,
  images,
  catalog,
  seasonCode,
  modelCode,
  modelDescription,
  materialCode,
  materialDescription,
  continuous,
  reversible,
  expanded,
  prices,
  checkForNext,
  imagedefault,
  rotationdefault,
}) {
  const lang = localStorage.getItem("B2BLanguage") == "ITA" ? "it" : "en";

  const dispatch = useDispatch();
  const navigate = useHistory();
  const reference = useRef();

  const { catalogue, catalogueItemDetailsSwap } = useSelector(
    (state) => state.yodaCatalogue,
  );

  const { me } = useSelector((state) => state.yodaStakeholders);
  const { orderRowDetails, order } = useSelector((state) => state.yodaOrders);
  const { customer } = useSelector((state) => state.yodaCustomer);

  const [popupImages, setPopupImages] = useState(false);
  const [focusValue, setFocusValue] = useState(false);
  const [descriptionExpand, setDescriptionExpand] = useState(false);

  const { isMobile, breakpoint } = useResponsive();
  const [buttonTableView, setButtonTableView] = useState(false);
  const [tableView, setTableView] = useState(false);
  const changeTableView = () => {
    setTableView(!tableView);
  };

  useEffect(() => {
    if (expanded) {
      dispatch(yodaCatalogueActions.getOneSwap(customer?.id, id, seasonCode));
      if (!isMobile) {
        const scrollContainer = document.getElementById("scrollContainer");
        scrollContainer.scrollTo({
          top: reference.current.offsetTop,
          behavior: "smooth",
        });
      }
    }
  }, [customer, dispatch, isMobile, expanded, id, seasonCode]);

  useEffect(() => {
    if (id) setButtonTableView(catalogueItemDetailsSwap[id]?.findSizes);
  }, [catalogueItemDetailsSwap]);

  const availabilityColorsMap = {
    green: "#249d4e",
    yellow: "#cea418",
    red: "#f04836",
  };

  function expand(event) {
    dispatch(systemActions.expandCatalogueItem(id));
  }

  function expandDescription(evt) {
    setDescriptionExpand(!descriptionExpand);
  }

  function close(event) {
    dispatch(systemActions.closeCatalogueItem());
    setDescriptionExpand(false);
  }

  function focus() {
    setFocusValue(true);
  }

  function unfocus() {
    setFocusValue(false);
  }

  function getAvgPrice(prices) {
    let tmpArr = catalogue?.filter((f) => f.productId == id)[0]?.catalog;
    if (tmpArr) {
      return Math.max(...tmpArr.map((m) => m.price));
    }
    return 0;
  }

  function calculatedColors() {
    let tmpArr = {};
    catalogueItemDetailsSwap[id]?.catalog?.map((e) => {
      if (tmpArr[e.colorCode] === undefined) {
        tmpArr[e.colorCode] = {
          colorDescription: getLocalizedText(e?.colorDescription),
          rgb: e.rgb,
          code: e.colorCode,
          values: [
            {
              size: e.size,
              sizeCode: e.sizeRowId,
              quantity: e.quantity,
            },
          ],
        };
      } else {
        tmpArr[e.colorCode].values.push({
          size: e.size,
          sizeCode: e.sizeRowId,
          quantity: e.quantity,
        });
      }
    });
    if (tmpArr === undefined) {
      return [];
    }

    let tmpArr2 = Object.keys(tmpArr).map(function (key) {
      return tmpArr[key];
    });

    return Array.from(tmpArr2);
  }

  const catalogColors = () => {
    return catalog?.map((c) => {
      return {
        ...c,
        colorDescription: getLocalizedText(c?.colorDescription),
        code: c.colorCode,
      };
    });
  };

  let totalQuantity = 0;
  let totalPrice = 0;

  let totalQuantityC = {};
  let totalPriceC = {};

  calculatedColors().map((e, index) => {
    if (order?.customData?.doors?.length) {
      order.customData.doors.map((d, idx) => {
        let catalogId = catalogue
          ?.filter((f) => f.productId == id)[0]
          ?.catalog.filter((f) => f.colorCode == e.code)[0].catalogId;
        let tmpArr = filter(
          orderRowDetails,
          (k, v) =>
            k.catalogId == catalogId &&
            d == k.customData.doorId &&
            k.customData.typeId == config.ORDER_TYPE_SWAP,
        );

        tmpArr.forEach((e1) => {
          totalQuantity += e1.currentQuantity;
          totalPrice += e1.price;

          if (totalQuantityC[e.code] == undefined) {
            totalQuantityC[e.code] = e1.currentQuantity;
          } else {
            totalQuantityC[e.code] += e1.currentQuantity;
          }

          if (totalPriceC[e.code] == undefined) {
            totalPriceC[e.code] = e1.price;
          } else {
            totalPriceC[e.code] += e1.price;
          }
        });
      });
    }
  });

  let catalogElement = catalogue?.filter((f) => f.productId == id)[0];

  const click = (id, color, door, idx) => {
    const numericPad = document.getElementById(
      [id, color, door, idx].join("_"),
    );
    numericPad.click();
  };

  return (
    <>
      {!expanded ? (
        <Flex
          id={checkForNext ? "checkForNext" : undefined}
          ref={reference}
          data-id={id}
          onClick={expand}
          w={1}
          style={{
            cursor: "pointer",
            border: focusValue ? "2px solid #d2d2d2" : "2px solid #f2f2f2",
          }}
        >
          {
            <Flex
              flexDirection={"column"}
              onMouseEnter={focus}
              onMouseLeave={unfocus}
              className="w-full grid grid-flow-row-dense items-stretch relative top-0 grid-cols-3 "
            >
              <ProductImage
                img={imagedefault?.length > 0 ? imagedefault : ""}
                width="100%"
                height={"230px"}
                scale={"1.2"}
              ></ProductImage>

              <Box
                sx={{
                  position: "absolute",
                  right: 10,
                  top: "3px",
                  zIndex: 1,
                  display: "none",
                }}
              >
                <Heart style={{ width: 24, color: "#d2d2d2" }} />
              </Box>
              <Tooltip content={getLocalizedString("NOTIFY_ME")}>
                <Box
                  sx={{
                    position: "absolute",
                    right: 72,
                    top: "8px",
                    cursor: "default !important",
                    "&:hover": {
                      "svg > path": {
                        stroke: "#a2a2a2 !important",
                      },
                    },
                  }}
                >
                  <Notify
                    style={{
                      height: 20,
                    }}
                    pathStyle={{
                      stroke: "#d2d2d2",
                    }}
                  />
                </Box>
              </Tooltip>
              <Tooltip content={getLocalizedString("ADD_TO_WISHLIST")}>
                <Box
                  sx={{
                    position: "absolute",
                    right: 40,
                    top: "8px",
                    cursor: "pointer",
                    "&:hover": {
                      "svg > path": {
                        stroke: "#a2a2a2 !important",
                      },
                    },
                  }}
                >
                  <Whishlist
                    style={{
                      height: 20,
                    }}
                    pathStyle={{
                      stroke: "#d2d2d2",
                    }}
                  />
                </Box>
              </Tooltip>
              {imagedefault !== "" && imagedefault?.length > 0 && (
                <Tooltip content={getLocalizedString("GALLERY")}>
                  <Box
                    sx={{
                      position: "absolute",
                      right: 10,
                      top: "3px",
                      cursor: "pointer",
                      "&:hover": {
                        "svg > g > g > path": {
                          stroke: "#a2a2a2",
                        },
                        "svg > g > g > circle": {
                          stroke: "#a2a2a2",
                        },
                      },
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setPopupImages(true);
                    }}
                  >
                    <Gallery style={{ width: 24, color: "#d2d2d2" }} />
                  </Box>
                </Tooltip>
              )}
              {(continuous > 0 || reversible > 0) && (
                <Tooltip
                  content={getLocalizedString(
                    continuous > 0 ? "CONTINUOUS" : "REVERSIBLE",
                  )}
                >
                  <Box
                    sx={{
                      position: "absolute",
                      left: 10,
                      width: "21px",
                      top: "10px",
                      zIndex: 1,
                      cursor: "pointer",
                      "&:hover": {
                        "svg g ": {
                          stroke: "#D2D2D2",
                        },
                        "svg g circle": {
                          stroke: "#D2D2D2",
                        },
                      },
                    }}
                  >
                    {continuous > 0 ? <Ccontinuous /> : null}

                    {reversible > 0 ? <Reversible /> : null}
                  </Box>
                </Tooltip>
              )}
              {/* PRODUCT DESCRIPTION */}
              <Flex
                w={1}
                p={["4px 8px 2px", 3]}
                flexDirection={"column"}
                justifyContent="flex-start"
                mt={-4}
                justifySelf={"flex-start"}
                alignItems={"left"}
                height={["100px", "130px"]}
                sx={{
                  width: "100%",
                  color: "#fff",
                  backgroundColor: focusValue ? "#f2f2f2" : "white",
                  zIndex: [0, 1],
                }}
              >
                <Flex
                  w={1}
                  style={{ fontWeight: "bold" }}
                  fontSize={"0.8em"}
                  color={"#232323"}
                  flex={"0 1"}
                >
                  <Price
                    price={getAvgPrice(catalog)}
                    previousText={modelCode + "/" + materialCode + " - "}
                    sx={{
                      fontSize: ["0.9em", "1em"],
                    }}
                  ></Price>
                </Flex>
                <Flex
                  w={1}
                  color={"#545454"}
                  sx={{
                    fontSize: ["0.6em", "0.7em"],
                    overflowY: "hidden",
                    flex: 1,
                    maxHeight: "30px",
                  }}
                >
                  {localStorage.getItem("B2BLanguage") == "ITA"
                    ? modelDescription["it"] + " " + materialDescription["it"]
                    : modelDescription["en"] + " " + materialDescription["en"]}
                </Flex>
                <Flex
                  flexDirection={["row", null, null, "row"]}
                  justifyContent="flex-start"
                  alignItems={"left"}
                  flexWrap="wrap"
                  fontSize={"0.6em"}
                  sx={{
                    gap: "6px",
                  }}
                >
                  {catalogColors()
                    .splice(0, breakpoint([3, 6, 6]))
                    .map((e, i) => (
                      <ColorTooltip
                        key={`color-${i}-${e?.code}`}
                        productId={id}
                        code={e.code}
                        colorDescription={e?.colorDescription || ""}
                        rgb={e?.rgb}
                        componentName={"catalogueProductReorderAndSwap"}
                        type={"REORDER"}
                        isCatalogue={true}
                        enableMobileTooltip
                        hideLabel
                      />
                    ))}
                  {catalogColors().length > breakpoint([3, 6, 6]) && (
                    <Box
                      sx={{
                        lineHeight: ".8em",
                        color: "#707070",
                        paddingTop: "13px",
                      }}
                    >
                      +&nbsp;{catalogColors().length - breakpoint([3, 6, 6])}
                      &nbsp;
                      {getLocalizedString(
                        catalogColors().length - breakpoint([3, 6, 6]) === 1
                          ? "PLUS_OTHER_SINGLE"
                          : "PLUS_OTHER",
                      )}
                    </Box>
                  )}
                </Flex>
              </Flex>
            </Flex>
          }
        </Flex>
      ) : (
        <Flex
          ref={reference}
          w={1}
          flexDirection={"column"}
          style={{
            gridColumn: "1 / -1",
            marginTop: -22,
            scrollMarginTop: "160px",
          }}
          fontSize={"0.9em"}
        >
          <Flex
            w={1}
            style={{
              position: "relative",
              gridColumn: "1 / -1",
              padding: "10px",
              color: "white",
              top: "16px",
            }}
          >
            <Box
              onClick={close}
              sx={{
                "svg > g > g > line": {
                  stroke: "black",
                },
              }}
              style={{
                cursor: "pointer",
                position: "relative",
                left: "calc(100% - 38px)",
                top: "10px",
                zIndex: 1,
                backgroundColor: "white",
              }}
            >
              <Close style={{ width: 24, height: 24 }}></Close>
            </Box>
          </Flex>
          <Flex
            w={1}
            style={{
              position: "relative",
              backgroundColor: "#232323",
              gridColumn: "1 / -1",
              padding: "16px",
              color: "white",
              top: "-30px",
            }}
          >
            <Box width={"35%"} style={{ position: "relative" }}>
              <ProductImage
                img={imagedefault?.length > 0 ? imagedefault : ""}
                width="100%"
                height={"210px"}
                scale={"1.2"}
              ></ProductImage>
              {imagedefault !== "" && imagedefault?.length > 0 && (
                <Tooltip content={getLocalizedString("GALLERY")}>
                  <Box
                    sx={{
                      position: "absolute",
                      right: 10,
                      top: "3px",
                      zIndex: 1,
                      cursor: "pointer",
                      "&:hover": {
                        "svg > g > g > path": {
                          stroke: "#a2a2a2",
                        },
                        "svg > g > g > circle": {
                          stroke: "#a2a2a2",
                        },
                      },
                    }}
                    onClick={(e) => {
                      setPopupImages(true);
                      e.preventDefault();
                    }}
                  >
                    <Gallery style={{ width: 24, color: "#d2d2d2" }} />
                  </Box>
                </Tooltip>
              )}
              <Flex width={1} p={2} bg={"white"} flexDirection={"column"}>
                <Flex
                  width={1}
                  justifyContent={"center"}
                  justifySelf="center"
                  bg={"white"}
                  color="black"
                  style={{
                    borderTop: "1px solid gray",
                    borderBottom: "1px solid gray",
                  }}
                >
                  {getLocalizedString("COLORS AVAILABILITY")}
                </Flex>
                <Flex
                  flexDirection={["column", "row"]}
                  justifyContent="left"
                  alignItems={"center"}
                  flexWrap="wrap"
                >
                  {calculatedColors().map((e, i) => (
                    <ColorTooltip
                      key={`color-${i}-${e?.code}`}
                      productId={id}
                      code={e.code}
                      colorDescription={e.colorDescription}
                      rgb={e.rgb}
                      componentName={"catalogueProductReorderAndSwap"}
                      type={"SWAP"}
                      enableMobileTooltip
                    />
                  ))}
                </Flex>
              </Flex>
              <Flex height="30px" bg={"white"}></Flex>
            </Box>
            <ProductDescription
              {...{
                id,
                modelCode,
                catalogueItemDetails: catalogueItemDetailsSwap,
                materialCode,
                descriptionExpand,
                expandDescription,
                prices,
              }}
              sx={{ width: "calc(100% / 3 * 2)" }}
            />
          </Flex>
          {/* COLOR GRIDS */}
          {calculatedColors().map((e, index) => {
            return (
              <Flex
                p={2}
                style={{
                  position: "relative",
                  top: "-30px",
                  padding: "10px 16px 0",
                }}
                bg="#232323"
                key={index}
              >
                <Flex bg="white" width={"100%"} overflowX={"auto"}>
                  <Box
                    w={1}
                    p={2}
                    sx={{
                      display: "grid",
                      gridGap: 0,
                      gridTemplateColumns:
                        "100px 120px " +
                        e.values.map((v) => "1fr ").join("") +
                        "50px 100px",
                    }}
                    width={1}
                  >
                    {/* ROW 1 */}
                    <Box
                      style={{
                        border: "1px solid #E0E0E0",
                        borderTop: 0,
                        borderBottom: 0,
                        borderLeft: 0,
                        textAlign: "center",
                        display: "flex",
                        justifyContent: "center",
                        width: "100%",
                        alignItems: "center",
                        minHeight: "35px",
                        fontSize: "12px",
                        background: "#fff",
                        position: "sticky",
                        left: 0,
                        zIndex: 1,
                      }}
                      w={1}
                    >
                      {getLocalizedString("COLOR")}
                    </Box>
                    <Box
                      style={{
                        border: "1px solid #E0E0E0",
                        borderTop: 0,
                        borderBottom: 0,
                        borderLeft: 0,
                        textAlign: "center",
                        display: "flex",
                        justifyContent: "center",
                        width: "100%",
                        alignItems: "center",
                        fontSize: "12px",
                        background: "#fff",
                        position: "sticky",
                        left: "100px",
                        zIndex: 1,
                        textDecoration: buttonTableView ? "underline" : "none",
                        cursor: buttonTableView ? "pointer" : "default",
                      }}
                      onClick={buttonTableView ? changeTableView : null}
                    >
                      <HangerBG
                        style={{
                          paddingRight: "10px",
                        }}
                      />
                      {getLocalizedString("SIZE")}
                    </Box>
                    {e.values.sort(sizeSort).map(
                      (e1, idx) => (
                        console.log(e1),
                        (
                          <Box
                            style={{
                              border: "1px solid #E0E0E0",
                              borderTop: 0,
                              borderLeft: 0,
                              borderBottom: 0,
                              textAlign: "center",
                              borderRight:
                                e?.values?.length - 1 == idx
                                  ? 0
                                  : "1px solid #E0E0E0",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              minWidth: "20px",
                            }}
                            color={"black"}
                            fontWeight="bold"
                            fontSize="12px"
                            key={idx}
                          >
                            <Flex
                              w={1}
                              alignItems={"center"}
                              justifyContent={"center"}
                            >
                              {e1?.size || ""}
                            </Flex>
                          </Box>
                        )
                      ),
                    )}
                    <Box
                      style={{
                        textAlign: "center",
                        borderBottom: "1px solid #F2F2F2",
                      }}
                    ></Box>
                    <Box
                      style={{
                        textAlign: "center",
                        borderBottom: "1px solid #F2F2F2",
                      }}
                    ></Box>
                    {/* END - ROW 1 */}
                    {/* ROW 2 */}
                    <Box
                      style={{
                        textAlign: "center",
                        border: "1px solid #E0E0E0",
                        borderLeft: 0,
                        borderBottom: 0,
                        gridRow:
                          "span " + (order?.customData?.doors?.length + 1),
                        background: "#fff",
                        position: "sticky",
                        left: 0,
                        zIndex: 1,
                      }}
                    >
                      <Box
                        style={{
                          fontWeight: "bold",
                          paddingTop: "6px",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                        }}
                      >
                        {e?.colorDescription?.toUpperCase()}
                      </Box>
                      <ColorTooltip
                        id={id}
                        code={e?.code}
                        colorDescription={e?.colorDescription}
                        rgb={e?.rgb}
                        componentName={"catalogueGrillReorderSwapAndPopup"}
                        type={"SWAP"}
                        enableMobileTooltip
                      />
                    </Box>
                    <Box
                      style={{
                        textAlign: "center",
                        border: "1px solid #E0E0E0",
                        borderLeft: 0,
                        borderBottom: "1px solid #E0E0E0",
                        display: "flex",
                        justifyContent: "center",
                        width: "100%",
                        alignItems: "center",
                        minHeight: "35px",
                        color: "#666666",
                        fontSize: "12px",
                        background: "#fff",
                        position: "sticky",
                        left: "100px",
                        zIndex: 1,
                      }}
                    >
                      {getLocalizedString("AVAILABILITY_SWAP")}
                    </Box>

                    {e?.values?.sort(sizeSort).map((e1, idx) => (
                      <Box
                        color={"white"}
                        style={{
                          textAlign: "center",
                          border: "1px solid #E0E0E0",
                          borderTop: 0,
                          borderLeft: 0,
                          display: "flex",
                          justifyContent: "center",
                          width: "100%",
                          alignItems: "center",
                          fontSize: "12px",
                        }}
                        bg={
                          e1.quantity > 0
                            ? availabilityColorsMap["green"]
                            : availabilityColorsMap["red"]
                        }
                        key={idx}
                      >
                        {e1.quantity}
                      </Box>
                    ))}

                    <Box
                      style={{
                        borderBottom: "1px solid #E0E0E0",
                        textAlign: "center",
                        display: "flex",
                        justifyContent: "center",
                        width: "100%",
                        alignItems: "center",
                        fontSize: "12px",
                      }}
                      bg={"#646464"}
                      color={"white"}
                    >
                      {getLocalizedString("QTA")}
                    </Box>
                    <Box
                      style={{
                        border: "1px solid #E0E0E0",
                        borderTop: 0,
                        textAlign: "center",
                        display: "flex",
                        justifyContent: "center",
                        width: "100%",
                        alignItems: "center",
                      }}
                      bg={"#646464"}
                      color={"white"}
                    >
                      {customer?.currencySymbol}
                    </Box>
                    {/* END - ROW 2 */}
                    {/* DOORS */}
                    {order?.customData?.doors?.map((doorId, idx) => (
                      <AvailabilityGridDoor
                        key={`door-${idx}-${doorId}`}
                        doorId={doorId}
                        color={e}
                        productId={id}
                        catalog={catalogElement?.catalog}
                        orderType={config.ORDER_TYPE_SWAP}
                      />
                    ))}
                    {/* END - DOORS */}
                    {/* COLOR TOTALS */}
                    <Box></Box>
                    <Box></Box>
                    {e?.values?.sort(sizeSort).map((e1, idx) => (
                      <Box key={idx}></Box>
                    ))}
                    <Box
                      style={{
                        fontWeight: "bold",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {totalQuantityC[e.code] || 0}
                    </Box>
                    <Box
                      style={{
                        fontWeight: "bold",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Price price={totalPriceC[e.code]}></Price>
                    </Box>
                    {/* END - COLOR TOTALS */}
                  </Box>
                </Flex>
              </Flex>
            );
          })}
          {/* END - COLOR GRIDS */}
          {/* PRODUCT TOTALS */}
          <Flex
            p={2}
            w={1}
            style={{ position: "relative", top: "-30px" }}
            bg="#232323"
          >
            <Box
              w={1}
              p={2}
              sx={{
                display: "grid",
                gridGap: 0,
                color: "white",
                gridTemplateColumns: "100px 120px 1fr 50px 100px",
                borderTop: "1px solid #C2C2C2",
                borderBottom: "1px solid #C2C2C2",
              }}
              width={1}
            >
              <Box
                style={{
                  fontWeight: "bold",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              ></Box>
              <Box
                style={{
                  fontWeight: "bold",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              ></Box>
              <Box
                style={{
                  fontWeight: "bold",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "right",
                }}
              >
                {getLocalizedString("TOTALE")}
              </Box>
              <Box
                style={{
                  fontWeight: "bold",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {totalQuantity || 0}
              </Box>
              <Box
                style={{
                  fontWeight: "bold",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderLeft: "1px solid #C2C2C2",
                }}
              >
                <Price price={totalPrice}></Price>
              </Box>
            </Box>
          </Flex>
          {/* END - PRODUCT TOTALS */}
          <Flex
            p={2}
            pb={3}
            w={1}
            style={{
              position: "relative",
              top: "-30px",
              alignItems: "center",
              justifyContent: "center",
            }}
            bg="#232323"
          >
            <Button
              variant="primary"
              style={{
                fontFamily: "Open Sans",
                fontSize: 12,
                fontWeigth: 800,
                color: "#000",
                width: "220px",
                background: "#fff",
                textTransform: "uppercase",
              }}
              onClick={() => {
                close();
                //localStorage.setItem('selectedAgent', id);
                //navigate.push("/users/" + id)
              }}
              mr={3}
            >
              {getLocalizedString("Continua")}
            </Button>
            <Button
              variant="primary"
              style={{
                fontFamily: "Open Sans",
                fontSize: 12,
                fontWeigth: 800,
                color: "#000",
                width: "220px",
                background: "#fff",
                textTransform: "uppercase",
              }}
              onClick={() => {
                navigate.push("/orderDetail/" + order.id);
              }}
            >
              {getLocalizedString("Visualizza carrello")}
            </Button>
          </Flex>
        </Flex>
      )}
      {tableView && <TableSize onClose={changeTableView} />}
      <PopupImages
        id={id}
        open={popupImages}
        close={() => setPopupImages(false)}
        data={images}
        imageDefault={imagedefault?.length > 0 ? imagedefault : ""}
        type={"SWAP"}
        {...{ rotationdefault }}
      />
    </>
  );
}

export { ProductSwapNew };
